<template>
  <div class="using-help">
    <nav-bar class="nav-bar" titleText="使用帮助" fontColor="#333333" @goBack="goBack"></nav-bar>

    <div class="problem-list">
      <div class="row">
        <div class="problem">1.卡包充值方式有哪些？</div>
        <div class="answer">目前只支持到店及线上充值</div>
      </div>
      <div class="row">
        <div class="problem">2.卡包充值后多久到账？</div>
        <p class="answer">充值金额将立即到账，您可在【余额】查看实时余额</p>
      </div>
      <div class="row">
        <div class="problem">3.卡包怎么使用？</div>
        <div class="answer">到店消费后扫销巴商家收款码可选择卡包支付</div>
      </div>
      <div class="row">
        <div class="problem">4.卡包充值后是否可以退款？</div>
        <div class="answer">目前卡包充值完成不支持退款</div>
      </div>
      <div class="row">
        <div class="problem">5.积分获得</div>
        <div class="answer">卡包充值完成后即可获得同等积分，到店消费后则不会获得积分</div>
      </div>
      <div class="row">
        <div class="problem">6.赠送金额</div>
        <div class="answer">赠送金额仅在本店使用。如果在当前店铺充值有赠送金 额，下次在该店使用卡包支付时赠送金额优先扣减</div>
      </div>
    </div>
  </div>
</template>

<script>
import navBar from './components/navBar'
export default {
  name:"usingHelp",
  data() {
    return {
      
    }
  },
  components:{
    navBar,
  },
  methods:{
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>


<style lang="less">
.using-help {
  padding-top: 88px;
  background: #FFFFFF;
  .problem-list {
    width: 100%;
    box-sizing: border-box;
    .row {
      padding: 10px 12px;
      box-sizing: border-box;
      border-bottom: 1px solid #f1f1f1;
      .problem {
        height: 22px;
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        box-sizing: border-box;
      }
      .answer {
        // height: 20px;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        padding-top: 10px;
        box-sizing: border-box;
      }
    }
  }
}
</style>